import axios from 'axios'
const BASE_API_URL = process.env.REACT_APP_API_URL

export const GET_ADMIN_COUNT = `${BASE_API_URL}/Dashboard/GetAdminDashboard`
export const GET_DAILY_RAM_NAME = `${BASE_API_URL}/DigitalRAMNameTransaction/GetLastNDaysDigitalRamNameCount`
export const GET_DEVICE_BREAKDOWN = `${BASE_API_URL}/DigitalRAMNameTransaction/GetDigitalRamNameDeviceBreakdown`
export const GET_MEMBER_STATUS = `${BASE_API_URL}/DigitalRAMNameTransaction/GetMemberStatusSummary`
export const GET_OS_BREAKDOWN = `${BASE_API_URL}/DigitalRAMNameTransaction/GetDigitalRamNameOSBreakdown`

export function getAdminCountApi() {
  return axios.post(GET_ADMIN_COUNT)
}
export function getDailyRamNameApi(memberId = 0, days = 7) {
  return axios.get(GET_DAILY_RAM_NAME, {params: {memberId, days}})
}
export function getDeviceBreakdownApi(memberId = 0) {
  return axios.get(GET_DEVICE_BREAKDOWN, {params: {memberId}})
}
export function getMemberStatusSummaryApi() {
  return axios.get(GET_MEMBER_STATUS)
}
export function getOSBreakdownApi(memberId = 0) {
  return axios.get(GET_OS_BREAKDOWN, {params: {memberId}})
}
